import React from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";
import CustomDatePicker from "../../../components/Custom-Datepicker";

const Dynamic_FilterForm = ({
  formData,
  handleChange,
  // handleDropDownChange,
  handleGetData,
  filterFormData,
  // jobtitleopts,
  // statusopts,
  // hropts,
  // sourceopts,
  // skillsopts,
}) => {
  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  // console.log("===>FormData", formData);
  console.log("===>filterFormData", filterFormData);

  return (
    <div className="container">
      <div className="row">
        <form onClick={stopPropagation}>
          <div className="row">
            {formData.map((ele, index) => (
              <div className="col-md-4" key={index}>
                <Form.Group className="">
                  <Form.Label className="mb-0">{ele?.name}</Form.Label>
                  {ele?.type === "Select" ? (
                    <Select
                      options={[
                        { value: '0', label: "Select..." },
                        ...ele?.options,
                      ]}
                      name="jobTitle"
                      placeholder={ele?.name}
                      // value={formData.jobTitle}
                      onChange={(e) => handleChange(e, ele?.name)}
                    />
                  ) : ele?.type === "Date" ? (
                    <CustomDatePicker
                      // handleChange={handleVsaEndDate}
                      // value={formData1.Vsa_End_Date}
                      handleChange={(e) =>
                        handleChange(e.target.value, ele?.name)
                      }
                      name="Vsa_End_Date"
                      id="VsaEndDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      // maxDate={new Date()}
                      value={
                        (filterFormData || []).find((o) => o.label === ele?.name) 
                          ? (filterFormData || []).find((o) => o.label === ele?.name)?.value 
                          : null
                      }
                    />
                  ) : ele?.type === "Text" ? (
                    <Form.Control
                      type="text"
                      name="candidateName"
                      // value={formData.candidateName}
                      onChange={(e) => handleChange(e.target.value, ele?.name)}
                    />
                  ) : ele?.type === "Number" ? (
                    <Form.Control
                      type="number"
                      name="candidateName"
                      // value={formData.candidateName}
                      // onChange={(e) => handleChange(e)}

                      onChange={(e) => handleChange(e.target.value, ele?.name)}
                    />
                  ) : null}
                </Form.Group>
              </div>
            ))}
          </div>

          {/* Uncomment and update the code below as needed */}
        </form>

        {/* Uncomment and update the code below as needed */}
        <div className="row mt-4">
          <div className="text-end">
            <button
              className="custom-btn"
              onClick={() => handleGetData()}
              type="button"
            >
              Get data
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dynamic_FilterForm;
